export const MOBILE_BREAKPOINT_MAX = 960;
export const DESKTOP_BREAKPOINT_MIN = 961;
export const DROPDOWN_CUSTOM_MOBILE_BREAKPOINT_MAX = 575;
export const DD_SEARCH_THRESHOLD = 10;
export const SEARCHBOX_INPUT_LENGTH = 45;

export const DROPDOWN_ITEM_HEIGHT = 35;
export const DROPDOWN_PADDINGS = 10;

export const GET_TRANSLATIONS = '/rest/model/schneider/common/web/WebLocalizationServiceActor/getTranslations';
export const GET_MODEL_LIST = '/tradeups/tradeUpData.jsp';
export const UPDATE_UPS_LIST = '/tradeups/tradeUpsPersist.jsp';
export const INITIAL_PATH = '/shop/tradeups/';
